module.exports = __webpack_public_path__ + "img/KM211.224.4e4d0f55.png";